import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_hdr_RowClass } from "../../../dbschema";

export class BotHdrContainerModel extends BaseContainerModel{
  alg_bot_hdr: alg_bot_hdr_RowClass = new alg_bot_hdr_RowClass();
}
